import { z } from "zod";

// Apart from the rest of the schemas, whose messages bring the whole of the agent copy: every
// screen validates its search with this, so it rides in every first load.

/** The conversation open in the Foreday panel, on any screen; a bad id opens nothing. */
export const openForedaySearch = z.object({
  foreday: z.string().min(1).optional().catch(undefined),
});
